export const KPIS = "KPIS";

export const getKpisData = (data, op) => {
  return {
    type: KPIS,
    payload: data,
    optype: op,
  };
};
